import React from 'react'
import Header from '../component/Header'
import Donate from '../component/Donate'
import BottomBar from '../component/BottomBar'

function Emergencies() {
  return (
    <div className='home' >
        <Header/>
        <div className='about_head_spacer'></div>
        <div className='donatebanner' >
            <div className='homebanner_overlay'>
                <div className='homebanner_container'>
                    <div className='homebanner_text' >
                        <div className='donatenow_banner_label' >
                            <h3>DONATE NOW</h3>
                        </div>
                    </div>

                    <div className='danate_desk'>
                        <Donate/>
                    </div>
                </div>
            </div>
        </div>

        <div className='danate_mob'>
          <Donate/>
        </div>
        
        <BottomBar/>
    </div>
  )
}

export default Emergencies